var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_003-email",
    "data-name": "003-email",
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.668,
    height: 43.852,
    viewBox: "0 0 47.668 43.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M158.5,85.994A9.082,9.082,0,0,0,170.68,94.35a.7.7,0,0,0-.478-1.312,7.626,7.626,0,0,1-2.717.462,7.735,7.735,0,0,1-7.593-7.538,7.681,7.681,0,1,1,14.936,2.381,1.452,1.452,0,0,1-1.375.968h0a1.461,1.461,0,0,1-1.46-1.46V82.1a.7.7,0,0,0-1.4,0v.5a4.422,4.422,0,1,0,.184,6.258,2.86,2.86,0,0,0,2.672,1.85h0a2.85,2.85,0,0,0,2.694-1.906A9.076,9.076,0,1,0,158.5,85.994Zm9.075,2.852A3.026,3.026,0,1,1,170.6,85.82,3.029,3.029,0,0,1,167.572,88.846Z",
    transform: "translate(-143.738 -71.504)",
    fill: "#f2025d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M47.4,37.121l-19.576-15.3a6.281,6.281,0,0,0-7.709-.023L.273,37.117A.7.7,0,0,0,0,37.671v6.144a.7.7,0,1,0,1.4,0V38.861l17.558,9.808L1.4,62.224V47.074a.7.7,0,0,0-1.4,0V63.645a.7.7,0,0,0,.7.7H46.968a.706.706,0,0,0,.7-.7V37.754a.729.729,0,0,0-.268-.633ZM2.745,62.947l18.22-14.066a4.885,4.885,0,0,1,6,.018l.336.263L36.051,56a.7.7,0,0,0,.86-1.1l-7.935-6.2,4.293-2.419a.7.7,0,0,0-.685-1.217l-4.8,2.7a6.279,6.279,0,0,0-7.626-.029L1.962,37.577l19-14.67a4.885,4.885,0,0,1,6,.018L45.782,37.631l-10.44,5.882a.7.7,0,0,0,.685,1.217l10.242-5.77V62.214L39.406,56.85a.7.7,0,1,0-.86,1.1l6.394,5H2.745Z",
    transform: "translate(0 -20.491)",
    fill: "#f2025d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.0800de36695c94d7eb393d0b1694dc17.svg";
export { ForwardRef as ReactComponent };